/* Header count = total quantity, not line-item count */
(function () {
  if (window.__ampSCCartCountFix) return;
  window.__ampSCCartCountFix = true;

  var COUNT_SEL = '#slidecarthq .cart-count';
  var deb = null;

  function apply() {
    var el = document.querySelector(COUNT_SEL);
    if (!el) return;

    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        el.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  function boot() {
    var host = document.querySelector('#slidecarthq');
    if (!host) return false;

    function fixAccessibility() {
      var overlay = host.querySelector('.slidecarthq-overlay');

      if (overlay) {
        overlay.setAttribute('aria-label', 'Close cart');
      }
    }

    new MutationObserver(function () {
      clearTimeout(deb);
      deb = setTimeout(function () {
        apply();
        fixAccessibility();
      }, 120);
    }).observe(host, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    apply();
    fixAccessibility();

    return true;
  }

  if (!boot()) {
    var tries = 0;
    var iv = setInterval(function () {
      if (boot() || ++tries > 60) clearInterval(iv);
    }, 500);
  }
})();